var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportSummary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2451.33 2027.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{filter:url(#drop-shadow-1);}.cls-1,.cls-2,.cls-3,.cls-4{fill:#fff;stroke:#e6e7e8;stroke-width:4.9px;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{stroke-miterlimit:10;}.cls-2{filter:url(#drop-shadow-3);}.cls-3{filter:url(#drop-shadow-2);}.cls-4{filter:url(#drop-shadow-4);}.cls-5{stroke:#6d6e71;stroke-width:58.83px;}.cls-5,.cls-6,.cls-7{fill:none;stroke-linecap:round;}.cls-8{fill:#4bbf44;mix-blend-mode:multiply;}.cls-6{stroke:#a7a9ac;stroke-width:19.67px;}.cls-9{isolation:isolate;}.cls-7{stroke:#d1d3d4;stroke-width:23.6px;}"), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 17.65
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 0
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 17.65
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 0
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 17.65
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 0
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-4",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 17.65
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 0
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 725.7,
    y: -215.7,
    width: 1500.13,
    height: 1941.34,
    rx: 21.24,
    ry: 21.24,
    transform: "translate(2230.73 -720.79) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 859.14,
    y: 358.74,
    width: 205.46,
    height: 57.2,
    rx: 25.45,
    ry: 25.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1167.03,
    y: 358.74,
    width: 205.46,
    height: 57.2,
    rx: 25.45,
    ry: 25.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1475.76,
    y: 358.74,
    width: 205.46,
    height: 57.2,
    rx: 25.45,
    ry: 25.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1784.49,
    y: 358.74,
    width: 205.46,
    height: 57.2,
    rx: 25.45,
    ry: 25.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 2093.22,
    y: 358.74,
    width: 205.46,
    height: 57.2,
    rx: 25.45,
    ry: 25.45
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 619.57,
    y1: 302.19,
    x2: 2339.36,
    y2: 302.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 619.57,
    y1: 472.07,
    x2: 2339.36,
    y2: 472.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 619.57,
    y1: 704.25,
    x2: 2339.36,
    y2: 704.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 619.57,
    y1: 936.43,
    x2: 2339.36,
    y2: 936.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 619.57,
    y1: 1168.61,
    x2: 2339.36,
    y2: 1168.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 619.57,
    y1: 1400.78,
    x2: 2339.36,
    y2: 1400.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 619.57,
    y1: 1381.69,
    x2: 619.57,
    y2: 302.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 2339.36,
    y1: 1400.78,
    x2: 2339.36,
    y2: 302.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1424.36,
    y1: 1381.69,
    x2: 1424.36,
    y2: 302.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 2034.36,
    y1: 1381.69,
    x2: 2034.36,
    y2: 302.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 814.36,
    y1: 1381.69,
    x2: 814.36,
    y2: 302.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1119.36,
    y1: 1381.69,
    x2: 1119.36,
    y2: 302.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1729.36,
    y1: 1381.69,
    x2: 1729.36,
    y2: 302.19
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 1084.03,
    y1: 152.07,
    x2: 1874.9,
    y2: 152.07
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 882.2,
    y1: 543.3,
    x2: 1048.91,
    y2: 543.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 882.2,
    y1: 586.59,
    x2: 1048.91,
    y2: 586.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 882.2,
    y1: 629.88,
    x2: 1008.46,
    y2: 629.88
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 882.2,
    y1: 782.85,
    x2: 1048.91,
    y2: 782.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 882.2,
    y1: 826.15,
    x2: 1048.91,
    y2: 826.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 882.2,
    y1: 869.44,
    x2: 1008.46,
    y2: 869.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 882.2,
    y1: 1016.51,
    x2: 1048.91,
    y2: 1016.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 882.2,
    y1: 1059.8,
    x2: 1048.91,
    y2: 1059.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 882.2,
    y1: 1103.09,
    x2: 1008.46,
    y2: 1103.09
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 882.2,
    y1: 1250.16,
    x2: 1048.91,
    y2: 1250.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 882.2,
    y1: 1293.46,
    x2: 1048.91,
    y2: 1293.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 882.2,
    y1: 1336.75,
    x2: 1008.46,
    y2: 1336.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1186.4,
    y1: 543.3,
    x2: 1353.12,
    y2: 543.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1186.4,
    y1: 586.59,
    x2: 1353.12,
    y2: 586.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1186.4,
    y1: 629.88,
    x2: 1312.66,
    y2: 629.88
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1186.4,
    y1: 782.85,
    x2: 1353.12,
    y2: 782.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1186.4,
    y1: 826.15,
    x2: 1353.12,
    y2: 826.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1186.4,
    y1: 869.44,
    x2: 1312.66,
    y2: 869.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1186.4,
    y1: 1016.51,
    x2: 1353.12,
    y2: 1016.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1186.4,
    y1: 1059.8,
    x2: 1353.12,
    y2: 1059.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1186.4,
    y1: 1103.09,
    x2: 1312.66,
    y2: 1103.09
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1186.4,
    y1: 1250.16,
    x2: 1353.12,
    y2: 1250.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1186.4,
    y1: 1293.46,
    x2: 1353.12,
    y2: 1293.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1186.4,
    y1: 1336.75,
    x2: 1312.66,
    y2: 1336.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1490.61,
    y1: 543.3,
    x2: 1657.32,
    y2: 543.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1490.61,
    y1: 586.59,
    x2: 1657.32,
    y2: 586.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1490.61,
    y1: 629.88,
    x2: 1616.87,
    y2: 629.88
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1490.61,
    y1: 782.85,
    x2: 1657.32,
    y2: 782.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1490.61,
    y1: 826.15,
    x2: 1657.32,
    y2: 826.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1490.61,
    y1: 869.44,
    x2: 1616.87,
    y2: 869.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1490.61,
    y1: 1016.51,
    x2: 1657.32,
    y2: 1016.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1490.61,
    y1: 1059.8,
    x2: 1657.32,
    y2: 1059.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1490.61,
    y1: 1103.09,
    x2: 1616.87,
    y2: 1103.09
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1490.61,
    y1: 1250.16,
    x2: 1657.32,
    y2: 1250.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1490.61,
    y1: 1293.46,
    x2: 1657.32,
    y2: 1293.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1490.61,
    y1: 1336.75,
    x2: 1616.87,
    y2: 1336.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1794.82,
    y1: 543.3,
    x2: 1961.53,
    y2: 543.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1794.82,
    y1: 586.59,
    x2: 1961.53,
    y2: 586.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1794.82,
    y1: 629.88,
    x2: 1921.08,
    y2: 629.88
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1794.82,
    y1: 782.85,
    x2: 1961.53,
    y2: 782.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1794.82,
    y1: 826.15,
    x2: 1961.53,
    y2: 826.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1794.82,
    y1: 869.44,
    x2: 1921.08,
    y2: 869.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1794.82,
    y1: 1016.51,
    x2: 1961.53,
    y2: 1016.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1794.82,
    y1: 1059.8,
    x2: 1961.53,
    y2: 1059.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1794.82,
    y1: 1103.09,
    x2: 1921.08,
    y2: 1103.09
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1794.82,
    y1: 1250.16,
    x2: 1961.53,
    y2: 1250.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1794.82,
    y1: 1293.46,
    x2: 1961.53,
    y2: 1293.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1794.82,
    y1: 1336.75,
    x2: 1921.08,
    y2: 1336.75
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2099.02,
    y1: 543.3,
    x2: 2265.74,
    y2: 543.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2099.02,
    y1: 586.59,
    x2: 2265.74,
    y2: 586.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2099.02,
    y1: 629.88,
    x2: 2225.28,
    y2: 629.88
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2099.02,
    y1: 782.85,
    x2: 2265.74,
    y2: 782.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2099.02,
    y1: 826.15,
    x2: 2265.74,
    y2: 826.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2099.02,
    y1: 869.44,
    x2: 2225.28,
    y2: 869.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2099.02,
    y1: 1016.51,
    x2: 2265.74,
    y2: 1016.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2099.02,
    y1: 1059.8,
    x2: 2265.74,
    y2: 1059.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2099.02,
    y1: 1103.09,
    x2: 2225.28,
    y2: 1103.09
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2099.02,
    y1: 1250.16,
    x2: 2265.74,
    y2: 1250.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2099.02,
    y1: 1293.46,
    x2: 2265.74,
    y2: 1293.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 2099.02,
    y1: 1336.75,
    x2: 2225.28,
    y2: 1336.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 558.97,
    y: -48.98,
    width: 1500.13,
    height: 1941.34,
    rx: 21.24,
    ry: 21.24,
    transform: "translate(2230.73 -387.34) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 692.41,
    y: 525.47,
    width: 205.46,
    height: 57.2,
    rx: 25.45,
    ry: 25.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1000.3,
    y: 525.47,
    width: 205.46,
    height: 57.2,
    rx: 25.45,
    ry: 25.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1309.03,
    y: 525.47,
    width: 205.46,
    height: 57.2,
    rx: 25.45,
    ry: 25.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1617.76,
    y: 525.47,
    width: 205.46,
    height: 57.2,
    rx: 25.45,
    ry: 25.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1926.5,
    y: 525.47,
    width: 205.46,
    height: 57.2,
    rx: 25.45,
    ry: 25.45
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 452.84,
    y1: 468.92,
    x2: 2172.64,
    y2: 468.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 452.84,
    y1: 638.8,
    x2: 2172.64,
    y2: 638.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 452.84,
    y1: 870.98,
    x2: 2172.64,
    y2: 870.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 452.84,
    y1: 1103.16,
    x2: 2172.64,
    y2: 1103.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 452.84,
    y1: 1335.33,
    x2: 2172.64,
    y2: 1335.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 452.84,
    y1: 1567.51,
    x2: 2172.64,
    y2: 1567.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 452.84,
    y1: 1548.41,
    x2: 452.84,
    y2: 468.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 2172.64,
    y1: 1567.51,
    x2: 2172.64,
    y2: 468.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1257.63,
    y1: 1548.41,
    x2: 1257.63,
    y2: 468.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1867.63,
    y1: 1548.41,
    x2: 1867.63,
    y2: 468.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 647.63,
    y1: 1548.41,
    x2: 647.63,
    y2: 468.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 952.63,
    y1: 1548.41,
    x2: 952.63,
    y2: 468.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1562.63,
    y1: 1548.41,
    x2: 1562.63,
    y2: 468.92
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 917.3,
    y1: 318.8,
    x2: 1708.17,
    y2: 318.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 715.47,
    y1: 710.03,
    x2: 882.18,
    y2: 710.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 715.47,
    y1: 753.32,
    x2: 882.18,
    y2: 753.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 715.47,
    y1: 796.61,
    x2: 841.73,
    y2: 796.61
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 715.47,
    y1: 949.58,
    x2: 882.18,
    y2: 949.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 715.47,
    y1: 992.87,
    x2: 882.18,
    y2: 992.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 715.47,
    y1: 1036.17,
    x2: 841.73,
    y2: 1036.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 715.47,
    y1: 1183.24,
    x2: 882.18,
    y2: 1183.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 715.47,
    y1: 1226.53,
    x2: 882.18,
    y2: 1226.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 715.47,
    y1: 1269.82,
    x2: 841.73,
    y2: 1269.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 715.47,
    y1: 1416.89,
    x2: 882.18,
    y2: 1416.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 715.47,
    y1: 1460.19,
    x2: 882.18,
    y2: 1460.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 715.47,
    y1: 1503.48,
    x2: 841.73,
    y2: 1503.48
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1019.67,
    y1: 710.03,
    x2: 1186.39,
    y2: 710.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1019.67,
    y1: 753.32,
    x2: 1186.39,
    y2: 753.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1019.67,
    y1: 796.61,
    x2: 1145.93,
    y2: 796.61
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1019.67,
    y1: 949.58,
    x2: 1186.39,
    y2: 949.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1019.67,
    y1: 992.87,
    x2: 1186.39,
    y2: 992.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1019.67,
    y1: 1036.17,
    x2: 1145.93,
    y2: 1036.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1019.67,
    y1: 1183.24,
    x2: 1186.39,
    y2: 1183.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1019.67,
    y1: 1226.53,
    x2: 1186.39,
    y2: 1226.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1019.67,
    y1: 1269.82,
    x2: 1145.93,
    y2: 1269.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1019.67,
    y1: 1416.89,
    x2: 1186.39,
    y2: 1416.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1019.67,
    y1: 1460.19,
    x2: 1186.39,
    y2: 1460.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1019.67,
    y1: 1503.48,
    x2: 1145.93,
    y2: 1503.48
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1323.88,
    y1: 710.03,
    x2: 1490.59,
    y2: 710.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1323.88,
    y1: 753.32,
    x2: 1490.59,
    y2: 753.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1323.88,
    y1: 796.61,
    x2: 1450.14,
    y2: 796.61
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1323.88,
    y1: 949.58,
    x2: 1490.59,
    y2: 949.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1323.88,
    y1: 992.87,
    x2: 1490.59,
    y2: 992.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1323.88,
    y1: 1036.17,
    x2: 1450.14,
    y2: 1036.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1323.88,
    y1: 1183.24,
    x2: 1490.59,
    y2: 1183.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1323.88,
    y1: 1226.53,
    x2: 1490.59,
    y2: 1226.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1323.88,
    y1: 1269.82,
    x2: 1450.14,
    y2: 1269.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1323.88,
    y1: 1416.89,
    x2: 1490.59,
    y2: 1416.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1323.88,
    y1: 1460.19,
    x2: 1490.59,
    y2: 1460.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1323.88,
    y1: 1503.48,
    x2: 1450.14,
    y2: 1503.48
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1628.09,
    y1: 710.03,
    x2: 1794.8,
    y2: 710.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1628.09,
    y1: 753.32,
    x2: 1794.8,
    y2: 753.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1628.09,
    y1: 796.61,
    x2: 1754.35,
    y2: 796.61
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1628.09,
    y1: 949.58,
    x2: 1794.8,
    y2: 949.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1628.09,
    y1: 992.87,
    x2: 1794.8,
    y2: 992.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1628.09,
    y1: 1036.17,
    x2: 1754.35,
    y2: 1036.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1628.09,
    y1: 1183.24,
    x2: 1794.8,
    y2: 1183.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1628.09,
    y1: 1226.53,
    x2: 1794.8,
    y2: 1226.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1628.09,
    y1: 1269.82,
    x2: 1754.35,
    y2: 1269.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1628.09,
    y1: 1416.89,
    x2: 1794.8,
    y2: 1416.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1628.09,
    y1: 1460.19,
    x2: 1794.8,
    y2: 1460.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1628.09,
    y1: 1503.48,
    x2: 1754.35,
    y2: 1503.48
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1932.29,
    y1: 710.03,
    x2: 2099.01,
    y2: 710.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1932.29,
    y1: 753.32,
    x2: 2099.01,
    y2: 753.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1932.29,
    y1: 796.61,
    x2: 2058.56,
    y2: 796.61
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1932.29,
    y1: 949.58,
    x2: 2099.01,
    y2: 949.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1932.29,
    y1: 992.87,
    x2: 2099.01,
    y2: 992.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1932.29,
    y1: 1036.17,
    x2: 2058.56,
    y2: 1036.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1932.29,
    y1: 1183.24,
    x2: 2099.01,
    y2: 1183.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1932.29,
    y1: 1226.53,
    x2: 2099.01,
    y2: 1226.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1932.29,
    y1: 1269.82,
    x2: 2058.56,
    y2: 1269.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1932.29,
    y1: 1416.89,
    x2: 2099.01,
    y2: 1416.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1932.29,
    y1: 1460.19,
    x2: 2099.01,
    y2: 1460.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1932.29,
    y1: 1503.48,
    x2: 2058.56,
    y2: 1503.48
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 392.24,
    y: 117.75,
    width: 1500.13,
    height: 1941.34,
    rx: 21.24,
    ry: 21.24,
    transform: "translate(2230.73 -53.88) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 525.69,
    y: 692.2,
    width: 205.46,
    height: 57.2,
    rx: 25.45,
    ry: 25.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 833.57,
    y: 692.2,
    width: 205.46,
    height: 57.2,
    rx: 25.45,
    ry: 25.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1142.3,
    y: 692.2,
    width: 205.46,
    height: 57.2,
    rx: 25.45,
    ry: 25.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1451.03,
    y: 692.2,
    width: 205.46,
    height: 57.2,
    rx: 25.45,
    ry: 25.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1759.77,
    y: 692.2,
    width: 205.46,
    height: 57.2,
    rx: 25.45,
    ry: 25.45
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 286.11,
    y1: 635.65,
    x2: 2005.91,
    y2: 635.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 286.11,
    y1: 805.53,
    x2: 2005.91,
    y2: 805.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 286.11,
    y1: 1037.71,
    x2: 2005.91,
    y2: 1037.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 286.11,
    y1: 1269.88,
    x2: 2005.91,
    y2: 1269.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 286.11,
    y1: 1502.06,
    x2: 2005.91,
    y2: 1502.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 286.11,
    y1: 1734.24,
    x2: 2005.91,
    y2: 1734.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 286.11,
    y1: 1715.14,
    x2: 286.11,
    y2: 635.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 2005.91,
    y1: 1734.24,
    x2: 2005.91,
    y2: 635.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1090.9,
    y1: 1715.14,
    x2: 1090.9,
    y2: 635.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1700.91,
    y1: 1715.14,
    x2: 1700.91,
    y2: 635.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 480.9,
    y1: 1715.14,
    x2: 480.9,
    y2: 635.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 785.9,
    y1: 1715.14,
    x2: 785.9,
    y2: 635.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1395.9,
    y1: 1715.14,
    x2: 1395.9,
    y2: 635.65
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 750.58,
    y1: 485.53,
    x2: 1541.44,
    y2: 485.53
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 548.74,
    y1: 876.75,
    x2: 715.45,
    y2: 876.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 548.74,
    y1: 920.05,
    x2: 715.45,
    y2: 920.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 548.74,
    y1: 963.34,
    x2: 675,
    y2: 963.34
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 548.74,
    y1: 1116.31,
    x2: 715.45,
    y2: 1116.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 548.74,
    y1: 1159.6,
    x2: 715.45,
    y2: 1159.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 548.74,
    y1: 1202.9,
    x2: 675,
    y2: 1202.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 548.74,
    y1: 1349.97,
    x2: 715.45,
    y2: 1349.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 548.74,
    y1: 1393.26,
    x2: 715.45,
    y2: 1393.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 548.74,
    y1: 1436.55,
    x2: 675,
    y2: 1436.55
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 548.74,
    y1: 1583.62,
    x2: 715.45,
    y2: 1583.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 548.74,
    y1: 1626.91,
    x2: 715.45,
    y2: 1626.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 548.74,
    y1: 1670.21,
    x2: 675,
    y2: 1670.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 852.94,
    y1: 876.75,
    x2: 1019.66,
    y2: 876.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 852.94,
    y1: 920.05,
    x2: 1019.66,
    y2: 920.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 852.94,
    y1: 963.34,
    x2: 979.21,
    y2: 963.34
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 852.94,
    y1: 1116.31,
    x2: 1019.66,
    y2: 1116.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 852.94,
    y1: 1159.6,
    x2: 1019.66,
    y2: 1159.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 852.94,
    y1: 1202.9,
    x2: 979.21,
    y2: 1202.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 852.94,
    y1: 1349.97,
    x2: 1019.66,
    y2: 1349.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 852.94,
    y1: 1393.26,
    x2: 1019.66,
    y2: 1393.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 852.94,
    y1: 1436.55,
    x2: 979.21,
    y2: 1436.55
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 852.94,
    y1: 1583.62,
    x2: 1019.66,
    y2: 1583.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 852.94,
    y1: 1626.91,
    x2: 1019.66,
    y2: 1626.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 852.94,
    y1: 1670.21,
    x2: 979.21,
    y2: 1670.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1157.15,
    y1: 876.75,
    x2: 1323.86,
    y2: 876.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1157.15,
    y1: 920.05,
    x2: 1323.86,
    y2: 920.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1157.15,
    y1: 963.34,
    x2: 1283.41,
    y2: 963.34
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1157.15,
    y1: 1116.31,
    x2: 1323.86,
    y2: 1116.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1157.15,
    y1: 1159.6,
    x2: 1323.86,
    y2: 1159.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1157.15,
    y1: 1202.9,
    x2: 1283.41,
    y2: 1202.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1157.15,
    y1: 1349.97,
    x2: 1323.86,
    y2: 1349.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1157.15,
    y1: 1393.26,
    x2: 1323.86,
    y2: 1393.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1157.15,
    y1: 1436.55,
    x2: 1283.41,
    y2: 1436.55
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1157.15,
    y1: 1583.62,
    x2: 1323.86,
    y2: 1583.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1157.15,
    y1: 1626.91,
    x2: 1323.86,
    y2: 1626.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1157.15,
    y1: 1670.21,
    x2: 1283.41,
    y2: 1670.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1461.36,
    y1: 876.75,
    x2: 1628.07,
    y2: 876.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1461.36,
    y1: 920.05,
    x2: 1628.07,
    y2: 920.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1461.36,
    y1: 963.34,
    x2: 1587.62,
    y2: 963.34
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1461.36,
    y1: 1116.31,
    x2: 1628.07,
    y2: 1116.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1461.36,
    y1: 1159.6,
    x2: 1628.07,
    y2: 1159.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1461.36,
    y1: 1202.9,
    x2: 1587.62,
    y2: 1202.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1461.36,
    y1: 1349.97,
    x2: 1628.07,
    y2: 1349.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1461.36,
    y1: 1393.26,
    x2: 1628.07,
    y2: 1393.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1461.36,
    y1: 1436.55,
    x2: 1587.62,
    y2: 1436.55
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1461.36,
    y1: 1583.62,
    x2: 1628.07,
    y2: 1583.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1461.36,
    y1: 1626.91,
    x2: 1628.07,
    y2: 1626.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1461.36,
    y1: 1670.21,
    x2: 1587.62,
    y2: 1670.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1765.56,
    y1: 876.75,
    x2: 1932.28,
    y2: 876.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1765.56,
    y1: 920.05,
    x2: 1932.28,
    y2: 920.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1765.56,
    y1: 963.34,
    x2: 1891.83,
    y2: 963.34
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1765.56,
    y1: 1116.31,
    x2: 1932.28,
    y2: 1116.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1765.56,
    y1: 1159.6,
    x2: 1932.28,
    y2: 1159.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1765.56,
    y1: 1202.9,
    x2: 1891.83,
    y2: 1202.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1765.56,
    y1: 1349.97,
    x2: 1932.28,
    y2: 1349.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1765.56,
    y1: 1393.26,
    x2: 1932.28,
    y2: 1393.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1765.56,
    y1: 1436.55,
    x2: 1891.83,
    y2: 1436.55
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1765.56,
    y1: 1583.62,
    x2: 1932.28,
    y2: 1583.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1765.56,
    y1: 1626.91,
    x2: 1932.28,
    y2: 1626.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1765.56,
    y1: 1670.21,
    x2: 1891.83,
    y2: 1670.21
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 225.51,
    y: 284.48,
    width: 1500.13,
    height: 1941.34,
    rx: 21.24,
    ry: 21.24,
    transform: "translate(2230.73 279.58) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 358.96,
    y: 858.93,
    width: 205.46,
    height: 57.2,
    rx: 25.45,
    ry: 25.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 666.84,
    y: 858.93,
    width: 205.46,
    height: 57.2,
    rx: 25.45,
    ry: 25.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 975.57,
    y: 858.93,
    width: 205.46,
    height: 57.2,
    rx: 25.45,
    ry: 25.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1284.31,
    y: 858.93,
    width: 205.46,
    height: 57.2,
    rx: 25.45,
    ry: 25.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1593.04,
    y: 858.93,
    width: 205.46,
    height: 57.2,
    rx: 25.45,
    ry: 25.45
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 119.38,
    y1: 802.37,
    x2: 1839.18,
    y2: 802.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 119.38,
    y1: 972.26,
    x2: 1839.18,
    y2: 972.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 119.38,
    y1: 1204.44,
    x2: 1839.18,
    y2: 1204.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 119.38,
    y1: 1436.61,
    x2: 1839.18,
    y2: 1436.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 119.38,
    y1: 1668.79,
    x2: 1839.18,
    y2: 1668.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 119.38,
    y1: 1900.97,
    x2: 1839.18,
    y2: 1900.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 119.38,
    y1: 1881.87,
    x2: 119.38,
    y2: 802.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1839.18,
    y1: 1900.97,
    x2: 1839.18,
    y2: 802.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 924.17,
    y1: 1881.87,
    x2: 924.17,
    y2: 802.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1534.18,
    y1: 1881.87,
    x2: 1534.18,
    y2: 802.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 314.17,
    y1: 1881.87,
    x2: 314.17,
    y2: 802.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 619.17,
    y1: 1881.87,
    x2: 619.17,
    y2: 802.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 1229.18,
    y1: 1881.87,
    x2: 1229.18,
    y2: 802.37
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 583.85,
    y1: 652.26,
    x2: 1374.71,
    y2: 652.26
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 382.01,
    y1: 1043.48,
    x2: 548.72,
    y2: 1043.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 382.01,
    y1: 1086.78,
    x2: 548.72,
    y2: 1086.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 382.01,
    y1: 1130.07,
    x2: 508.27,
    y2: 1130.07
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 382.01,
    y1: 1283.04,
    x2: 548.72,
    y2: 1283.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 382.01,
    y1: 1326.33,
    x2: 548.72,
    y2: 1326.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 382.01,
    y1: 1369.62,
    x2: 508.27,
    y2: 1369.62
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 382.01,
    y1: 1516.7,
    x2: 548.72,
    y2: 1516.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 382.01,
    y1: 1559.99,
    x2: 548.72,
    y2: 1559.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 382.01,
    y1: 1603.28,
    x2: 508.27,
    y2: 1603.28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 382.01,
    y1: 1750.35,
    x2: 548.72,
    y2: 1750.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 382.01,
    y1: 1793.64,
    x2: 548.72,
    y2: 1793.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 382.01,
    y1: 1836.94,
    x2: 508.27,
    y2: 1836.94
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 686.22,
    y1: 1043.48,
    x2: 852.93,
    y2: 1043.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 686.22,
    y1: 1086.78,
    x2: 852.93,
    y2: 1086.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 686.22,
    y1: 1130.07,
    x2: 812.48,
    y2: 1130.07
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 686.22,
    y1: 1283.04,
    x2: 852.93,
    y2: 1283.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 686.22,
    y1: 1326.33,
    x2: 852.93,
    y2: 1326.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 686.22,
    y1: 1369.62,
    x2: 812.48,
    y2: 1369.62
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 686.22,
    y1: 1516.7,
    x2: 852.93,
    y2: 1516.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 686.22,
    y1: 1559.99,
    x2: 852.93,
    y2: 1559.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 686.22,
    y1: 1603.28,
    x2: 812.48,
    y2: 1603.28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 686.22,
    y1: 1750.35,
    x2: 852.93,
    y2: 1750.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 686.22,
    y1: 1793.64,
    x2: 852.93,
    y2: 1793.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 686.22,
    y1: 1836.94,
    x2: 812.48,
    y2: 1836.94
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 990.42,
    y1: 1043.48,
    x2: 1157.14,
    y2: 1043.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 990.42,
    y1: 1086.78,
    x2: 1157.14,
    y2: 1086.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 990.42,
    y1: 1130.07,
    x2: 1116.68,
    y2: 1130.07
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 990.42,
    y1: 1283.04,
    x2: 1157.14,
    y2: 1283.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 990.42,
    y1: 1326.33,
    x2: 1157.14,
    y2: 1326.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 990.42,
    y1: 1369.62,
    x2: 1116.68,
    y2: 1369.62
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 990.42,
    y1: 1516.7,
    x2: 1157.14,
    y2: 1516.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 990.42,
    y1: 1559.99,
    x2: 1157.14,
    y2: 1559.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 990.42,
    y1: 1603.28,
    x2: 1116.68,
    y2: 1603.28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 990.42,
    y1: 1750.35,
    x2: 1157.14,
    y2: 1750.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 990.42,
    y1: 1793.64,
    x2: 1157.14,
    y2: 1793.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 990.42,
    y1: 1836.94,
    x2: 1116.68,
    y2: 1836.94
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1294.63,
    y1: 1043.48,
    x2: 1461.34,
    y2: 1043.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1294.63,
    y1: 1086.78,
    x2: 1461.34,
    y2: 1086.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1294.63,
    y1: 1130.07,
    x2: 1420.89,
    y2: 1130.07
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1294.63,
    y1: 1283.04,
    x2: 1461.34,
    y2: 1283.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1294.63,
    y1: 1326.33,
    x2: 1461.34,
    y2: 1326.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1294.63,
    y1: 1369.62,
    x2: 1420.89,
    y2: 1369.62
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1294.63,
    y1: 1516.7,
    x2: 1461.34,
    y2: 1516.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1294.63,
    y1: 1559.99,
    x2: 1461.34,
    y2: 1559.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1294.63,
    y1: 1603.28,
    x2: 1420.89,
    y2: 1603.28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1294.63,
    y1: 1750.35,
    x2: 1461.34,
    y2: 1750.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1294.63,
    y1: 1793.64,
    x2: 1461.34,
    y2: 1793.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1294.63,
    y1: 1836.94,
    x2: 1420.89,
    y2: 1836.94
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1598.84,
    y1: 1043.48,
    x2: 1765.55,
    y2: 1043.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1598.84,
    y1: 1086.78,
    x2: 1765.55,
    y2: 1086.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1598.84,
    y1: 1130.07,
    x2: 1725.1,
    y2: 1130.07
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1598.84,
    y1: 1283.04,
    x2: 1765.55,
    y2: 1283.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1598.84,
    y1: 1326.33,
    x2: 1765.55,
    y2: 1326.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1598.84,
    y1: 1369.62,
    x2: 1725.1,
    y2: 1369.62
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1598.84,
    y1: 1516.7,
    x2: 1765.55,
    y2: 1516.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1598.84,
    y1: 1559.99,
    x2: 1765.55,
    y2: 1559.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1598.84,
    y1: 1603.28,
    x2: 1725.1,
    y2: 1603.28
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1598.84,
    y1: 1750.35,
    x2: 1765.55,
    y2: 1750.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1598.84,
    y1: 1793.64,
    x2: 1765.55,
    y2: 1793.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1598.84,
    y1: 1836.94,
    x2: 1725.1,
    y2: 1836.94
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportSummary);
export default __webpack_public_path__ + "static/media/reportSummary.6e18adbc.svg";
export { ForwardRef as ReactComponent };